/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize MyStage View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './MyStageView';
/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsMyStage = mapStateToProps;
export const mapDispatchToPropsMyStage = mapDispatchToProps;

export default connect(mapStateToPropsMyStage, mapDispatchToPropsMyStage)(View);
